import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
export var ValidationError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(ValidationError, _Error);

  function ValidationError(message) {
    var _this;

    _this = _Error.call(this, message) || this;
    _this.name = "ValidationError";
    _this.message = message;
    return _this;
  }

  return ValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));